import React from "react";
import CheckDetail from "./CheckDetail";
import { connect } from "react-redux";
import { startSetSymlinkCheck } from "../actions/checks";

class CustomSymlink extends React.Component {
  componentDidMount() {
    this.props.startSetSymlinkCheck(
      this.props.match.params.token,
      this.props.match.params.org
    );
  }

  render() {
    return (
      <div className="route-container">
        <div className="page">
          {this.props.symlinkMonitor && (
            <CheckDetail
              id={`${this.props.symlinkMonitor.id}`}
              isShare={true}
            />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  symlinkMonitor: state.checks.find(
    (el) =>
      el.token === props.match.params.token.slice(0, 36)
  ),
});

const mapDispatchToProps = (dispatch) => ({
  startSetSymlinkCheck: (token, org) =>
    dispatch(startSetSymlinkCheck(token, org)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomSymlink);
